import styled, { css } from 'styled-components';

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: space-between;
    overflow: hidden;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      min-width: 228px;
    }
  `}
`;

export const CardContent = styled.div`
  ${() => css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    position: relative;
    width: 50%;

    @media (max-width: 1366px) {
      padding: 16px;
      width: 70%;
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${() => css`
    object-fit: cover;
    line-height: 0;
    max-width: 50%;

    @media (max-width: 1366px) {
      display: flex;
      justify-content: flex-end;
      max-width: 30%;
    }
  `};
`;

export const Image = styled.img`
  ${() => css`
    height: 100%;
    
    @media (max-width: 1366px) {
      max-height: 218px;
    }
  `}
`;

export const WrapperTagPro = styled.div`
  ${() => css`
    left: 24px;
    position: absolute;
    top: 24px;

    @media (max-width: 1366px) {
      left: 16px;
      top: 16px;
    }
  `}
`;

export const WrapperTitle = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    min-height: 60px;

    @media (max-width: 1366px) {
      min-height: 42px;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 1.5;
    margin: 0;

    @media (max-width: 1366px) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.5;
    margin: 0;

    @media (max-width: 1366px) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
